import React from 'react'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Markdown from 'components/atoms/MarkdownContent'

import { string } from 'prop-types'

const MajorCollege = ({ title, imgSrc, imgAlt, content }) => (
  <div id="campus-life" className="major-college">
    <SectionContainer marginTop={120}>
      <Row>
        <Col lg="5">
          <img src={imgSrc} alt={imgAlt} className="major-college__image"/>
        </Col>
        <Col lg="7">
          <Container className="major-college__detail">
            <SectionTitle title={title} align="left" />
            <Markdown className="major-college__content" content={content}/>
          </Container>
        </Col>
      </Row>
    </SectionContainer>
    <style jsx>
      {`
        .major-college {
          &__image {
            width: 100%;
          }
          :global(&__detail) {
            margin-top: 40px;
            @media screen and (min-width: 768px) {
              margin-top: unset;
            }
            @media screen and (min-width: 1024px) {
              margin-right: 80px !important;
            }
            @media screen and (min-width: 1025px) {
              margin-left: 80px !important;
            }
          }
          :global(&__content) {
            font-size: 16px;
            line-height: 1.5;
          }
        }
      `}
    </style>
  </div>
)

MajorCollege.propTypes = {
  title: string,
  imgSrc: string,
  imgAlt: string,
  content: string,
}

export default MajorCollege
